import { IWorkspaceResourceAsset } from "common/interfaces";

import { app } from "js/namespaces";

export function buildTeamAssetMetadata({
    fromAssetId,
    assetResource,
    assetModel,
    attributesOverrides = {},
}: {
    fromAssetId: string;
    assetResource?: IWorkspaceResourceAsset | null;
    assetModel?: { get: (key: string) => any } | null;
    attributesOverrides?: { description?: string; isPublished?: boolean; name?: string; type?: string };
}) {
    return {
        type: attributesOverrides.type ?? assetResource?.metadata?.type ?? assetModel?.get("type"),
        createdBy: assetResource?.metadata?.createdBy ?? app.user.id,
        modifiedBy: assetResource?.metadata?.modifiedBy ?? app.user.id,
        name: attributesOverrides.name ?? assetResource?.metadata?.name ?? assetModel?.get("assetName"),
        alt: attributesOverrides.description ?? assetResource?.metadata?.alt ?? assetResource?.metadata?.description ?? assetModel?.get("name") ?? "",
        isPublished: attributesOverrides.isPublished ?? assetResource?.metadata?.isPublished ?? true,
        actualId: fromAssetId,
    };
}
